import {
  TEDCustomDateTimeDisplayer,
  IInternalDateFormat,
} from './TEDCustomDateTimeDisplayer';
import { TEDParseDateTimeMode, ValueType } from '../FormatterTypes';
import { BaseDisplayer } from './BaseDisplayer';
import { formatterStrParamDef } from '../Utils/ParamUtils';
import { extractDateString } from '../Utils/TimeDateUtils';
import { booleanToString } from '../Utils/ValueUtils';

class TEDDisplayDateStr extends TEDCustomDateTimeDisplayer {
  public static getInstance(): BaseDisplayer {
    return this.instance || (this.instance = new this());
  }

  private static instance: BaseDisplayer;

  defaultParams(): string {
    return 'DateSep="-";HideCentury="N"';
  }

  mode(): TEDParseDateTimeMode {
    return TEDParseDateTimeMode.pdmDateString;
  }

  asDateTime(
    value: ValueType,
    params: string,
    defaultParams: string
  ): IInternalDateFormat {
    const valAsStr = valueToDateString(value, params, this.defaultParams());
    const tm = parseInt(valAsStr.slice(4, 6), 10);
    const td = parseInt(valAsStr.slice(6, 8), 10);
    return {
      ty: parseInt(valAsStr.slice(0, 4), 10) || -1,
      tm: tm ? tm : tm === 0 ? tm : -1,
      td: td ? td : td === 0 ? td : -1,
      th: -1,
      tn: -1,
      ts: -1,
      tms: -1,
    };
  }
}

const valueToDateString = (
  value: ValueType,
  params: string,
  defaultParams: string
): string => {
  let result = '';
  switch (typeof value) {
    case 'string':
      result = String(value);
      break;
    case 'number': {
      // assume it is a datetime double...
      const numVal = Number(value);
      //   const frac: number = numVal - Math.ceil(numVal);
      const dateSep: string = formatterStrParamDef(
        'DateSep',
        params,
        defaultParams,
        '-'
      );

      result = extractDateString(numVal, dateSep);

      break;
    }
    case 'boolean':
      result = booleanToString(Boolean(value));
  }

  return result;
};

export { TEDDisplayDateStr };
